import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F02A94",
      "fill-rule": "evenodd",
      d: "M250 500c138.075 0 250-111.925 250-250S388.075 0 250 0 0 111.925 0 250s111.925 250 250 250m91.675-365.5a24.32 24.32 0 0 1 16.95-9.4 23.62 23.62 0 0 1 18.125 6.35c5.1 4.8 8.175 11.35 8.6 18.325.5 7.125-1.675 14.15-6 19.55l-156 196.325a24.1 24.1 0 0 1-18.425 9.35h-.375a23.96 23.96 0 0 1-18.3-8.7l-75.575-89.25c-9.225-11.15-8.55-27.5 1.575-37.85 9.875-9.975 26.225-9.175 35.05 1.725l56.65 66.9 137.725-173.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M358.625 125.1c-6.7.65-12.825 4.05-16.95 9.375l-137.7 173.35-56.675-66.9c-8.825-10.9-25.175-11.7-35.05-1.725-10.125 10.35-10.8 26.7-1.575 37.85l75.575 89.25a23.96 23.96 0 0 0 18.3 8.7h.375a24.07 24.07 0 0 0 18.45-9.35l155.95-196.325c4.35-5.4 6.5-12.425 6.025-19.55a27.46 27.46 0 0 0-8.6-18.325 23.62 23.62 0 0 0-18.125-6.35",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }